import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useUserDBContext } from '../contexts/UserDBContext';
import { useTranslation } from 'react-i18next';
import franceFlag from '../assets/img/flag-france.jpg';
import ukFlag from '../assets/img/flag-en.jpg';
import './style/NavBar.css';
import { FaBars } from 'react-icons/fa';
import logoBOW from '../assets/img/logobeonwall.png';
import { FaCog } from 'react-icons/fa';


function NavBar() {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { userDBData } = useUserDBContext();
  const { i18n } = useTranslation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);
  const [appMenuOpen, setAppMenuOpen] = useState(false);

  const changeLanguage = (lng) => i18n.changeLanguage(lng);

  const handleLogout = async () => {
    await signOut();
    setMenuOpen(false);
  };

  const getTrialMessage = () => {
    if (!userDBData || userDBData.subscriptions !== 'P0') return null;
    const createdAt = new Date(userDBData.createdAt);
    const today = new Date();
    const diffDays = Math.floor((today - createdAt) / (1000 * 60 * 60 * 24));
    const remaining = 7 - diffDays;
    return remaining > 0 ? `Essai expire dans ${remaining} jour${remaining > 1 ? 's' : ''}` : null;
  };

  const trialMessage = getTrialMessage();
  const currentLang = i18n.language;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1100);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const { t } = useTranslation();
  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo">
        <img src={logoBOW} alt="BeOnWall Logo" className="logo-img" />
      </Link>


      {isMobile ? (
        <>
          <button className="burger-btn" onClick={() => setMenuOpen(!menuOpen)}>
            <FaBars />
          </button>

          <div className="language-switcher">
            <img
              src={franceFlag}
              alt="FR"
              onClick={() => changeLanguage('fr')}
              style={{ width: '24px', cursor: 'pointer', opacity: currentLang === 'fr' ? 1 : 0.5 }}
            />
            <img
              src={ukFlag}
              alt="EN"
              onClick={() => changeLanguage('en')}
              style={{ width: '24px', marginLeft: '8px', cursor: 'pointer', opacity: currentLang === 'en' ? 1 : 0.5 }}
            />
          </div>
          {/* Mobile menu */}
          <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
            {!user ? (
              <>
                <Link to="/" onClick={() => setMenuOpen(false)}>{t('BeOnWall')}</Link>
                <Link to="/WallofLove" onClick={() => setMenuOpen(false)}>{t('WallOfLove')}</Link>
                
                  <div className="appname-toggle-wrapper">
                    <button className="appname-toggle-button" onClick={() => setAppMenuOpen(!appMenuOpen)}>
                      {t('Help')} <span className="dropdown-arrow">▼</span>
                    </button>
                    {appMenuOpen && (
                      <div className="appname-toggle-content">
                        <Link to="/guides" onClick={() => setMenuOpen(false)}>Guides</Link>
                        <Link to="/contacts" onClick={() => setMenuOpen(false)}>Contacts</Link>
                      </div>
                    )}
                  </div>


                <Link to="/pricing" onClick={() => setMenuOpen(false)}>{t('Pricing')}</Link>
                <Link to="/login" className="auth-button" onClick={() => setMenuOpen(false)}>Login</Link>
              </>
            ) : (
              <>
                <Link to="/create-event" onClick={() => setMenuOpen(false)}>{t('CreateEvent')}</Link>
                <Link to="/events" onClick={() => setMenuOpen(false)}>{t('Event')}</Link>
                <Link to="/guides" onClick={() => setMenuOpen(false)}>Guides</Link>
                <Link to="/pricing" onClick={() => setMenuOpen(false)}>{t('Pricing')}</Link>                              
                <Link to="/profile" onClick={() => setMenuOpen(false)}>{t('Profil')}</Link>
                {/* ... autres éléments du menu ... */}
                <Link
                  to="/generalsettings"
                  className="nav-icon-link-settings"
                  title="Paramètres Général"
                  aria-label="Open general settings"
                >
                  <FaCog className="nav-cog-icon" />
                  <span className="nav-cog-text"> Paramètres Général</span>
                </Link>

                {trialMessage && (
                  <Link to="/pricing" className="navbar-trial-message" onClick={() => setMenuOpen(false)}>
                    {trialMessage}
                  </Link>
                )}
                <button onClick={handleLogout} className="auth-button">{t('Logout')}</button>
              </>
            )}
          </div>
        </>
      ) : (
        // Desktop menu
        <div className="navbar-links">
          {!user ? (
            
            <>
              <Link to="/">{t('BeOnWall')}</Link>
              <Link to="/WallofLove">{t('WallOfLove')}</Link>
              <div className="dropdown">
                <span className="dropdown-title">{t('Help')} <span className="dropdown-arrow">▼</span></span>
                <div className="dropdown-content">
                  <Link to="/guides">Guides</Link>
                  <Link to="/contacts">Contacts</Link>
                </div>
              </div>
              <Link to="/pricing">{t('Pricing')}</Link>
              <div className="language-switcher">
                <img src={franceFlag} alt="FR" onClick={() => changeLanguage('fr')} style={{ width: '24px', cursor: 'pointer', opacity: currentLang === 'fr' ? 1 : 0.5 }} />
                <img src={ukFlag} alt="EN" onClick={() => changeLanguage('en')} style={{ width: '24px', marginLeft: '8px', cursor: 'pointer', opacity: currentLang === 'en' ? 1 : 0.5 }} />
              </div>
              <Link to="/login" className="auth-button">{t('Login')}</Link>
            </>
          ) : (
            <>
              <Link to="/create-event">{t('createEvent')}</Link>
              <Link to="/events">{t('Event')}</Link>          
              <Link to="/guides" >Guides</Link>
              <Link to="/pricing">{t('Pricing')}</Link>             
              <Link to="/profile">{t('Profil')}</Link>
              {/* ... autres éléments du menu ... */}
              <Link
                to="/generalsettings"
                className="nav-icon-link-settings"
                title="Settings"
                aria-label="Open general settings"
              >
                <FaCog className="nav-cog-icon" /> {/* ← add this class */}
              </Link>



              {trialMessage && (
                <Link to="/pricing" className="navbar-trial-message">{trialMessage}</Link>
              )}
              <div className="language-switcher">
                <img src={franceFlag} alt="FR" onClick={() => changeLanguage('fr')} style={{ width: '24px', cursor: 'pointer', opacity: currentLang === 'fr' ? 1 : 0.5 }} />
                <img src={ukFlag} alt="EN" onClick={() => changeLanguage('en')} style={{ width: '24px', marginLeft: '8px', cursor: 'pointer', opacity: currentLang === 'en' ? 1 : 0.5 }} />
              </div>
              <button onClick={handleLogout} className="auth-button">{t('Logout')}</button>
            </>
          )}
        </div>
      )}
    </nav>
  );
}

export default NavBar;
